var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    class: [{
      simple: _vm.isSimple,
      tdk2: !_vm.isSimple
    }]
  }, _vm._l(_vm.splitText, function (letter, i) {
    return _c('span', {
      key: letter + i,
      class: [{
        spacebar: _vm.spacebarNow && _vm.isSimple,
        focusable: _vm.isCurrentCharacter(i)
      }, 'noselect', ("char" + (i + 1)), _vm.getClasses(i, letter)],
      attrs: {
        "role": _vm.isCurrentCharacter(i) ? 'region' : null,
        "aria-live": _vm.isCurrentCharacter(i) ? 'assertive' : null,
        "tabindex": _vm.isCurrentCharacter(i) ? 0 : -1
      },
      domProps: {
        "innerHTML": _vm._s(letter)
      }
    });
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }